/**
 * Created by slava on 4/21/17.
 */

const MyMailRuPayments = function () {
    RestPayments.call(this, connector.MM, {
        sdk: SdkManager.SDK_MYMAILRU
    });
};

MyMailRuPayments.prototype = Object.create(RestPayments.prototype);
MyMailRuPayments.prototype.constructor = MyMailRuPayments;

MyMailRuPayments.prototype.getDefaultCurrency = function () {
    return "MLK";
};

MyMailRuPayments.prototype.getProductId = function (product) {
    return product.id.mymailru;
};

MyMailRuPayments.prototype._connect = function (callback) {
    this.listeners = {
        status: function () {
        },
        income: function () {
        }
    };

    mailru.events.listen(mailru.app.events.paymentDialogStatus, (event) => {
        this.listeners.status(event);
    });

    mailru.events.listen(mailru.app.events.incomingPayment, (event) => {
        this.listeners.income(event);
    });

    callback(connector.STATUS_CONNECTED);
};

MyMailRuPayments.prototype.purchaseOpen = function (product, callback) {
    this.listeners.income = function (event) {
        console.log("[MM payments] event income", event);

        if (event.status === "success") {
            const purchase = this.createPurchase(undefined, product);

            callback(connector.CODE_SUCCEED, purchase);
        } else {
            callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: event.status });

            this.bus.trigger("stream:error", `MyMailRuPayments.purchase productId:${product.productId} ${JSON.stringify(event)}`);
        }
    }.bind(this);

    mailru.app.payments.showDialog({
        service_id: product.productId,
        service_name: product.title,
        mailiki_price: this.getPriceToBePaid(product)
    });
};

MyMailRuPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.MM);
};
